import { SaleType } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../components/ModuleProvider';
export const useIsSeasonalSale = () => {
  var _discountData$discoun;
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    data: discountData
  } = module.SDK.studioOfferingApiClient.hooks.useFetchOfferingDiscount({});
  if (!experiments.isEnabled('specs.premium.Studio_Sale_PREM2-19136')) {
    return false;
  }
  const saleType = discountData == null || (_discountData$discoun = discountData.discount) == null || (_discountData$discoun = _discountData$discoun.discountInfo) == null || (_discountData$discoun = _discountData$discoun.sale) == null ? void 0 : _discountData$discoun.saleType;
  return !!(discountData != null && discountData.hasSale) && saleType === SaleType.SEASONAL_SALE;
};
//# sourceMappingURL=useIsSeasonalSale.js.map